export type RouteConstant = {
  route: string;
  exact?: boolean;
  isProtected?: boolean;
  redirectTo?: string;
  props?: object;
};

const routeConstants: Record<string, RouteConstant> = {
  home: {
    route: '/',
    redirectTo: '/dashboard',
    exact: true
  },
  dashboard: {
    route: '/dashboard',
    exact: true,
    isProtected: true
  },
  login: {
    route: '/login',
    exact: true,
    isProtected: false
  },
  signup: {
    route: '/signup',
    exact: true,
    isProtected: false
  },
  editor: {
    route: '/editor/:id',
    exact: true,
    isProtected: true
  },
  forgotPassword: {
    route: '/forgotpassword',
    exact: true,
    isProtected: false
  },
  resetPassword: {
    route: '/resetpassword',
    exact: true,
    isProtected: false
  },
  unsubscribe: {
    route: '/unsubscribe',
    exact: true,
    isProtected: false
  },
  loginRedirect: {
    route: '/loginRedirect',
    exact: true,
    isProtected: false
  },
  privacyPolicy: {
    route: '/privacy-policy',
    exact: true,
    isProtected: false
  },
  termsAndConditions: {
    route: '/terms-and-conditions',
    exact: true,
    isProtected: false
  }
};

export type RouteKeys = keyof typeof routeConstants;

export default routeConstants;
